module.exports = __webpack_public_path__ + "assets/img/icon-heart.61bc5341.svg";